import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";

const useAdjustmentReasonCodeList = () => {
  const [data, setData] = useState([]);
  // const [paramsData, setParamsData] = useState({
  //   ad1AdjReasonCodeList: "",
  // });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { ADJUSTMENT_REASON_CODE_LIST_ADD } = ROUTE_PATHS;
  const { axios_helper_no_header } = useAxios();

  const screen_title = "Adjustment Reason Code List";
  // const screenNumber = "RCAD1001";

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);

  const {
    selectedSchedules = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    selectMode: initialSelectedMode = false,
    paramsData: initialParamsData = {
      ad1AdjReasonCodeList: "",
    },
  } = currentState;

  const [selectMode, setSelectedMode] = useState(initialSelectedMode);
  const [lookupType, setLookupType] = useState("local");
  const [selectParams, setSelectParams] = useState({});
  const screenNumber = selectMode ? "RCAD1005" : "RCAD1001";

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParamsData);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]
      ?.ad1AdjReasonCodeList;
  const updatedParamsData = {
    ...paramsData,
    ad1AdjReasonCodeList: lastScheduleName,
  };

  const formFields = selectMode
    ? [
        {
          fieldLabel: "AD1 Adj Reason Code List",
          name: "ad1AdjReasonCodeList",
          label: "List",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
      ]
    : [
        {
          fieldLabel: "AD1 Adj Reason Code List",
          name: "ad1AdjReasonCodeList",
          label: "List",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
      ];

  const handleBack = () => {
    console.log("***********************************");

    console.log("stateVal - ", stateVal);
    console.log("previousState - ", previousState);

    console.log("***********************************");

    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Adjustment Reason Code List",
          button_handeler: () => {
            navigateToPage(ADJUSTMENT_REASON_CODE_LIST_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              if (selectMode && lookupType === "external") {
                const paramDataMap = new Map();
                selectParams.forEach((key) => {
                if (rowData.hasOwnProperty(key["target"]) && key["source"]) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
                }
              });
                const paramData = Object.fromEntries(paramDataMap);
                const message = {
                  type: "responseData",
                  data: paramData,
                };
                window.parent.postMessage(message, "*");
              } else {
                console.log("***********************************");

                console.log("stateVal - ", stateVal);
                console.log("previousState - ", previousState);

                console.log("***********************************");

                const [latestPreviousState] = previousState.splice(
                  previousState.length - 1,
                  1
                );
                let { paramsData } = latestPreviousState;
                console.log("paramsData", paramsData, latestPreviousState);

                // const updatedParamsData={...paramsData,bmdScheduleCode:rowData[parmKey], bmdDescription:rowData[bmdDescription]};

                const updatedParamsData = {
                  ...paramsData,
                  adjustmentReasonCdeLst: rowData[parmKey],
                  adjRsnCdeLstDesc: rowData["ad1AdjRsnCdeLstDesc"],
                };
                const updatedLatestPreviousState = {
                  ...latestPreviousState,
                  initialParamsData: updatedParamsData,
                };
                navigateToPage(previousScreen, [
                  ...previousState,
                  updatedLatestPreviousState,
                ]);
              }
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCAD1002",
                parameters: {
                  ad1AdjReasonCodeList: rowData["ad1AdjReasonCodeList"],
                  ad1AdjRsnCdeLstDesc: rowData["ad1AdjRsnCdeLstDesc"],
                  workInitialProgramMode: "DSP",
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "ADJUSTMENT_REASON_CODE_LIST_READ_ONLY",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
          {
            label: "Adjustment Reason Codes",
            icon: <span className="material-icons">list</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCAD2003",
                parameters: {
                  ad1AdjReasonCodeList: rowData["ad1AdjReasonCodeList"],
                  ad1AdjRsnCdeLstDesc: rowData["ad1AdjRsnCdeLstDesc"],
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");*/
              if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "CODES_IN_ADJUSTMENT_REASON_CODES",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
        ]
      : [
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(ROUTE_PATHS.ADJUSTMENT_REASON_CODE_LIST_EDIT, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Copy/Merge",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              navigateToPage(
                ROUTE_PATHS.COPY_MERGE_ADJUSTMENT_REASON_CODE_LIST,
                [
                  {
                    ...currentState,
                    paramsData: updatedParamsData,
                    currentIndex: currentIndex,
                  },
                  {
                    selectedPriceSchedules: selectedRows.length
                      ? selectedRows
                      : [rowData],
                    previousScreen: location.pathname,
                  },
                ]
              );
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(ROUTE_PATHS.ADJUSTMENT_REASON_CODE_LIST_DISPLAY, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Adjustment Reason Codes",
            icon: <span className="material-icons">list</span>,
            command: () => {
              navigateToPage(ROUTE_PATHS.CODES_IN_ADJUSTMENT_REASON_CODE_LIST, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
        ];
  }, [rowData, selectedRows, selectMode, lookupType]);

  const columnDef = selectMode
    ? [
        {
          header: "List",
          field: "ad1AdjReasonCodeList",
        },
        {
          header: "Description",
          field: "ad1AdjRsnCdeLstDesc",
        },
      ]
    : [
        {
          header: "List",
          field: "ad1AdjReasonCodeList",
        },
        {
          header: "Description",
          field: "ad1AdjRsnCdeLstDesc",
        },
      ];

  const parmKey = "ad1AdjReasonCodeList";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/ad1AdjReasonCodeList`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAdjustmentReasonCodeList = () => {
    if (selectedOption === "yes") {
      const params = { ad1AdjReasonCodeList: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/ad1AdjReasonCodeList", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/ad1AdjReasonCodeList/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData(externalData?.paramsData);
        setSelectParams(externalData?.params);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    selectMode,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAdjustmentReasonCodeList,
    setSelectedOption,
  };
};

export default useAdjustmentReasonCodeList;
